import { push } from "connected-react-router";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { APPLICATION_MODE_NEW, APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE, LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION, ROUTE_PATH } from "../../app/constants";
import { ERROR_STRING } from "../../app/errors";
import { Button, ErrorMark, Header, Paragraph } from "../../components/RegularComponents";
import { setCompanyRjscDetails } from "../../redux/slice/rjscDetailReviewSlice";
import TopNavigationBar from "../TopNavigationBar";
import { applicationTypeFromLicenceSubType } from '../../redux/slice/applicationsUtils'
import { replaceUrlParams } from "../../app/utils";

const MLRJSCCompanyDetail = (props) => {
  const dispatch = useDispatch();

  const { isModal = false, onEditSave = () => {} } = props;

  const [rjscCompanyDetail, setRjscCompanyDetail] = useState("");
  const [rjscOtherCompanyDetail, setRjscOtherCompanyDetail] = useState("");
  const [showError, setShowError] = useState(false)

  const { applicationMode } = props.match.params

const { licencingSubType } = useSelector((state) => ({
  licencingSubType : state.primaryAgencyApplication.application?.licencingSubType ?? LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
}));

const applicationType = applicationTypeFromLicenceSubType(licencingSubType);
const isLender = (applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE)
const isMortgageAdministrator = (applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE)

  const companyRjscDetails = useSelector(
    (state) =>
      state.primaryAgencyApplication?.application?.businessLicenceData
        ?.companyRjscDetails ?? {}
  );

  const style = {
    otherStep: {
      backgroundColor: "white",
      borderStyle: "none",
      borderWidth: "1px",
      color: "black",
      left: "-19px",
    },
  };

  const handleNext = () => {
    if(!rjscCompanyDetail) {
      setShowError(true)
      return
    }

    setShowError(false)

    const updatedCompanyRJSCData = {
      authorized: false,
      businessContact: {
        civicAddress: {
          city: "",
          postalCode: "",
          province: "",
          street: "",
        },
        email: null,
        fax: null,
        mailingAddress: {
          city: "",
          postalCode: "",
          province: "",
          street: "",
        },
        phoneNumber: null,
      },
      businessData: {
        businessOwner: "",
        companyType: "Business Name",
        companyTypeId: null,
        expiryDate: "",
        peopleList: [],
        phoneNumber: null,
        relatedTo: "",
      },
      businessEntity: {
        businessName: "",
        entityId: "",
        registryNumber: "",
      },
      order: 0,
      notRegistered: rjscOtherCompanyDetail
        ? rjscOtherCompanyDetail
        : rjscCompanyDetail,
    };

    dispatch(
      setCompanyRjscDetails({
        ...companyRjscDetails,
        ...updatedCompanyRJSCData,
      })
    );

    // let nextRoutePath = isLender ? ROUTE_PATH.ML_APP : ROUTE_PATH.MA_APP
    if(isLender) {
      dispatch(
        !isModal
          ? push({
              pathname: `${ROUTE_PATH.ML_APP}${ROUTE_PATH.ML_RJSC_COMPANY_INFO}`,
            })
          : onEditSave()
      );
    }
    else if(isMortgageAdministrator){
      dispatch(
        !isModal
          ? push({
              pathname: `${ROUTE_PATH.MA_APP}${ROUTE_PATH.ML_RJSC_COMPANY_INFO}`,
            })
          : onEditSave()
      );
    }
    else {
      dispatch(
        !isModal
          ? push(replaceUrlParams(
                      ROUTE_PATH.RJSC_COMPANY_INFO,
                      applicationType,
                      applicationMode)
                  )
          : onEditSave()
      );
    }
  };

  return (
    <div className={!isModal ? "container" : ""}>
      {!isModal && (
        <>
          <TopNavigationBar {...props} 
                applicationType={applicationType} 
                applicationMode={APPLICATION_MODE_NEW}
            />
          {/* Title */}
          <div className="row">
            <div className="col-xs-12 col-lg-9">
              <Header
                id="ml-company-detail-header"
                header="Business not registered with the Nova Scotia Registry of joint Stock Companies (RJSC)"
              />
            </div>
          </div>
        </>
      )}

      <div className="row">
        <div className="col-xs-12 col-lg-9">
          <Paragraph
            id="ml-find-business-para"
            text={[
              "<b>Provide a reason why your company is not registered with RJSC</b>",
            ]}
          />
        </div>
      </div>

      <div className={"row"}>
        <div className={"col-9"}>
          <fieldset className="ns-fieldset">
            <div className={"ns-radios ns-radios--large"}>
              <div className="ns-radios__item">
                <input
                  className="ns-radios__input"
                  type={"radio"}
                  value={"NB Exempt"}
                  onChange={(e) => setRjscCompanyDetail(e.target.value)}
                  id={"rjsc-MlRJSCCompanyDetail-NBExmpt-input"}
                  name={"rjsc-MlRJSCCompanyDetail-input"}
                />
                <label
                  id={"rjsc-MLRJSCCompanyDetail-NBExmpt-label"}
                  className="ns-radios__label"
                  htmlFor={"rjsc-MLRJSCCompanyDetail-NBExmpt-input"}
                >
                  <span className="ns-label-span">
                    My company is registered in New Brunswick and is exempt from
                    registering in Nova Scotia
                  </span>
                </label>
              </div>
              <div className="ns-radios__item">
                <input
                  className="ns-radios__input"
                  type={"radio"}
                  value={"soleProprietor"}
                  onChange={(e) => setRjscCompanyDetail(e.target.value)}
                  id={"rjsc-MLRJSCCompanyDetail-SoleProprietor-input"}
                  name={"rjsc-MLRJSCCompanyDetail-input"}
                />
                <label
                  id={"rjsc-MLRJSCCompanyDetail-SoleProprietor-label"}
                  className="ns-radios__label"
                  htmlFor={"rjsc-MLRJSCCompanyDetail-SoleProprietor-input"}
                >
                  <span className="ns-label-span">
                    I am a sole proprietor operating under my own name
                  </span>
                </label>
              </div>

              <div
                style={{ marginLeft: "-55px", marginTop: "-10px" }}
                className="timeline ns-radios__item row"
              >
                <ol>
                  <li className="timeline-item col-md-12">
                    <div className="step-content col-md-12">
                      <span style={style.otherStep} className="step-counter">
                        <input
                          className="ns-radios__input"
                          type={"radio"}
                          value={"Other"}
                          onChange={(e) => setRjscCompanyDetail(e.target.value)}
                          id={"rjsc-MLRJSCCompanyDetail-SoleProprietor-input"}
                          name={"rjsc-MLRJSCCompanyDetail-input"}
                        />

                        <label
                          id={"rjsc-MLRJSCCompanyDetail-SoleProprietor-label"}
                          style={{ marginLeft: "25px", marginTop: "-10px" }}
                          className="ns-radios__label"
                          htmlFor={
                            "rjsc-MLRJSCCompanyDetail-SoleProprietor-input"
                          }
                        >
                          <span className="ns-label-span">Other</span>
                        </label>
                      </span>

                      <div className="row">
                        <div
                          style={{ marginTop: "50px", marginLeft: "-20px" }}
                          className="col-xs-12"
                        >
                          <label
                            id={"rjsc-company-other-text-label"}
                            htmlFor={"rjsc-company-other-text"}
                          >
                            <span className="ns-label-span">
                              Provide Details
                            </span>
                          </label>
                          <input
                            id="rjsc-company-other-text"
                            name="rjsc-company-other-text"
                            className="form-control ns-input fw-20"
                            type="text"
                            value={rjscOtherCompanyDetail}
                            onInput={(e) => {
                              setRjscOtherCompanyDetail(e.target.value);
                            }}
                            style={{ display: "inline" }}
                          />
                        </div>
                      </div>
                    </div>
                  </li>
                </ol>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8 topMarginNormal">
          <div className={"help-block" + (showError ? " has-error" : "")}>
            <Button
              id="rjsc-search-button"
              text={!isModal ? "Next" : "Save and close"}
              buttonType={"regular_primary"}
              onClick={handleNext}
            />
            {showError && ErrorMark()}
            {showError && (
              <div className="ns-error-message topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.SELECT_COMPANY_RJSC_DETAIILS}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MLRJSCCompanyDetail;
